<div class="content-layout" [brightsideWebFb]="{event_name: 'hardship_intro'}">
  <bw-action-article-legacy>
    <div header-actions>
      <ui-nav-exit-back
        [trackingDetail]="{ event_name: 'hardship_intro' }"
        [skipActionEmit]="true"
      ></ui-nav-exit-back>
    </div>
    <div header-title>
      <div class="flex">
        <typography-legacy text-small-regular color="var(--secondary-text)" class="pb-sm">
          {{ 'HARDSHIP_INTRO_DESC' | translate }}
        </typography-legacy>
        <typography-legacy title-large color="var(--primary-text)">
          {{ 'HARDSHIP_INTRO_TITLE' | translate }}
        </typography-legacy>
      </div>
    </div>
    <div content-section>
      <typography-legacy>{{ 'HARDSHIP_INTRO_DESC' | translate }}</typography-legacy>
      <typography-legacy>{{ 'HARDSHIP_INTRO_SUBHEADER' | translate }}</typography-legacy>
      <div class="mt-sm">
        @for (reason of eligibilityItems; track reason.key) {
          @if ((reason.key |translate).trim() !== '') {
            <div class="flex-row space-between">
              <div class="align-left mr-sm">
                <bw-icon-legacy [iconName]="reason.icon" [size]="24"></bw-icon-legacy>
              </div>
              <div class="flex-column flex-item-flexible">
                <typography-legacy text-medium-regular>{{reason.key|translate}}</typography-legacy>
              </div>
            </div>
          }
        }
      </div>

    </div>
    <div footer-actions>
      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'hardship_intro'}"
        (click)="openChat();">
        {{ 'HARDSHIP_INTRO_CTA' | translate }}
      </button>
    </div>

  </bw-action-article-legacy>
</div>
